import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonBulkUpdateFieldActionEnum } from '../../../constants.new';

@Component({
    selector: 'tax-authority-bulk-update-action',
    templateUrl: './tax.authority.bulk.update.action.component.html',
    styles: ['select {width:120px}'],
    standalone: false
})
export class TaxAuthorityBulkUpdateActionComponent implements OnInit {
    constructor() {
        this.possibleActions = [
            { name: 'No Change', value: Core.CommonBulkUpdateFieldActionEnum.NoChange },
            { name: 'Change To', value: Core.CommonBulkUpdateFieldActionEnum.ChangeTo },
            { name: 'Set to Blank', value: Core.CommonBulkUpdateFieldActionEnum.SetToBlank }
        ];
    }

    @Input() fieldAction: Core.CommonBulkUpdateFieldActionEnum;
    @Output() fieldActionChange = new EventEmitter<Core.CommonBulkUpdateFieldActionEnum>();
    @Input() requiredField: boolean;
    @Input() disabled: boolean;

    possibleActions: Compliance.NameValuePair<Core.CommonBulkUpdateFieldActionEnum>[];
    selectedAction: Core.CommonBulkUpdateFieldActionEnum = Core.CommonBulkUpdateFieldActionEnum.NoChange;

    ngOnInit(): void {
        if (this.requiredField) {
            this.possibleActions = this.possibleActions.filter(i => i.value !== Core.CommonBulkUpdateFieldActionEnum.SetToBlank);
        }
    }

    fieldActionChanged(action: Core.CommonBulkUpdateFieldActionEnum): void {
        this.selectedAction = action;
        this.fieldActionChange.next(action);
    }

    isSelected(action: CommonBulkUpdateFieldActionEnum): boolean {
        return action === CommonBulkUpdateFieldActionEnum.NoChange;
    }
}
